import { render, staticRenderFns } from "./CloseBoxCashRegister.vue?vue&type=template&id=48ec65fb&"
import script from "./CloseBoxCashRegister.vue?vue&type=script&lang=js&"
export * from "./CloseBoxCashRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports